export default __webpack_public_path__ + "static/media/fiber_new.1f6ff2e5.svg";